import { lazy } from 'react';

const InvoicesPage = lazy(() => import('../pages/Invoices.page'));
const AddInvoicePage = lazy(() => import('../pages/AddInvoice.page'));

const InvoicesRoutes = [
    {
        path: '/invoices',
        element: <InvoicesPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/invoices/add',
        element: <AddInvoicePage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { InvoicesRoutes };
